import { inputFieldsValidator } from './input-layout-validator';
import {
  AscendArchivesProgramV1,
  FrontEndProcessingModel,
  PackagesInputModel,
  ThresholdsModel,
} from '../contracts';
import { ProgramMetadataModel } from '../../common';
import { FieldDelimiter } from '../../../fields';
import { productInputValidator } from '../../validators/common';
import * as yup from 'yup';

const oneOfEnum = <T>(enumObject: { [s: string]: T } | ArrayLike<T>) =>
  yup.mixed<T>().oneOf(Object.values(enumObject));

export const thresholdsValidator = yup.object<ThresholdsModel>({
  validationThreshold: yup.number().min(0).max(100).required(),
  pinningThreshold: yup.number().min(0).max(100).required(),
});

export const frontendProcessingValidator = yup.object<FrontEndProcessingModel>({
  experianInputFileName: yup.string().label('File Name').required(),
  clientInputFileName: yup.string().label('Client File Name').required(),
  // inputQuantity: yup
  //   .number()
  //   .nullable(true)
  //   .transform((v) => {
  //     return v === '' || isNaN(v) ? null : v;
  //   })
  //   .positive()
  //   .min(1)
  //   .max(999999999999)
  //   .label('Number of records')

  //   .required(),
  inputLayout: inputFieldsValidator.required(),
  thresholds: thresholdsValidator.required(),
  inputHeader: yup.boolean().label('Has Headers?'),
  inputFormat: yup.string().oneOf(['CSV']).required(),
  inputDelim: oneOfEnum(FieldDelimiter).label('Delimiter').required(),
});

const packagesInputValidator = yup.object<PackagesInputModel>({
  frontEndProcessing: frontendProcessingValidator.required(),
});

const metadataValidator = yup.object<ProgramMetadataModel>({
  name: yup
    .string()
    .label('Name')
    .required('Name is required, this is usually auto populated.'),
  version: yup
    .string()
    .label('Version')
    .required('Version is required, this is usually auto populated.'),
});

export const ascendArchivesProgramV1Validator =
  yup.object<AscendArchivesProgramV1>({
    // status: oneOfEnum(ProgramStatus).label('Status').required(),
    programKey: yup
      .string()
      .label('Program Key')
      .required('Program Key is required, this is usually auto populated.'),
    subCode: yup
      .string()
      .label('Subscribe Code')
      .required()
      .length(7)
      .matches(/^\d{7}$/, 'Subscriber Code value: "${value}" is invalid.'),
    metadata: metadataValidator.required(),
    productInput: productInputValidator.required(),
    packagesInput: packagesInputValidator.required(),
  });

export { inputFieldsCombinationsValidator as ascendArchivesInputFieldsCombinationsValidator } from './input-layout-validator';
